/** The RelationshipOS product mark — "The Clasp": two interlocked rings, rotated -35°.
 *
 *  This is the PRODUCT's mark, not a clinic's. It belongs on RelationshipOS's own chrome:
 *  the "Powered by RelationshipOS" footers, and app-level loading states with no clinic
 *  context yet.
 *
 *  It must NOT stand in for a clinic's logo. Every `Activity` icon in Layout, PatientLayout
 *  and the two login pages is the fallback for `clinic.logo_url` and sits beside the
 *  clinic's own name — putting the vendor's mark there would brand a clinic's header with
 *  someone else's identity, which is the opposite of what the white-label settings promise
 *  ("Patients see your brand. RelationshipOS stays behind the scenes.").
 */
export default function RosMark({ size = 28, dark = false, className = "" }) {
  const clinic = dark ? "#F8FAFC" : "#1E293B";
  const patient = dark ? "#14B8A6" : "#0D9488";
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true"
         className={className} data-testid="ros-mark">
      <g transform="rotate(-35 50 50)" fill="none" strokeWidth="13">
        <circle cx="36" cy="50" r="20" stroke={clinic} />
        <circle cx="64" cy="50" r="20" stroke={patient} />
        <path d="M54.8 43.2 A20 20 0 0 0 42.8 31.2" stroke={clinic} />
      </g>
    </svg>
  );
}
